export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}user/budget/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/EmployeeBudget/index.js